
<template>
  <div>
    <table class="basic-table" style="width: 100%; border: 1px solid #e7e7e7">
      <thead>
        <tr
          style="
            background-color: #e7e7e7;
            height: 40px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #9a9a9a;
          "
        >
          <th style="width: 50px; border: 1px solid #e7e7e7">
            <el-checkbox
              v-model="allSelectValue"
              @change="allSelected($event)"
            />
          </th>
          <th style="width: 50px">序号</th>
          <th v-for="(item, index) in title" :key="index">{{ item }}</th>
        </tr>
      </thead>
      <tbody style="text-align: center" v-if="list.length > 0">
        <tr
          style="min-height: 40px; border: 1px solid #e7e7e7"
          v-for="(listItem, listIndex) in list"
          :key="listIndex"
        >
          <td class="tableBorderMy" style="width: 50px">
            <el-checkbox
              :value="listItem.checked"
              @change="allSelectedChange($event, listIndex)"
            />
          </td>
          <td class="tableBorderMy">{{ listIndex + 1 }}</td>
          <!-- 单号 -->
          <td class="tableBorderMy">{{ listItem.nos }}</td>
          <!-- 名称 -->
          <td>
            <div
              style="
                height: 43px;
                line-height: 43px;
                border-right: 1px solid #e7e7e7;
              "
              v-for="(singleItem, itemIndex) in listItem.detailList"
              :key="itemIndex"
              :class="{
                tableBorderMyBtn: !(
                  listItem.detailList.length - 1 ==
                  itemIndex
                ),
              }"
            >
              <el-checkbox v-model="singleItem.checked" @change="itemSelect($event,listIndex,itemIndex,singleItem.id)" />
              {{ singleItem.feeName }}
              <!-- 判断是否留border-bottom -->
              <!-- !(listItem.detailList.length - 1 == itemIndex) -->
            </div>
          </td>
          <!-- 金额 -->
          <td>
            <div
              style="
                height: 43px;
                line-height: 43px;
                border-right: 1px solid #e7e7e7;
              "
              v-for="(singleItem, itemIndex) in listItem.detailList"
              :key="itemIndex"
              :class="{
                tableBorderMyBtn: !(
                  listItem.detailList.length - 1 ==
                  itemIndex
                ),
              }"
            >
              {{ singleItem.amount }}
            </div>
          </td>
          <!-- 时间 -->
          <td>
            <div
              style="
                height: 43px;
                line-height: 43px;
                border-right: 1px solid #e7e7e7;
              "
              v-for="(singleItem, itemIndex) in listItem.detailList"
              :key="itemIndex"
              :class="{
                tableBorderMyBtn: !(
                  listItem.detailList.length - 1 ==
                  itemIndex
                ),
              }"
            >
              {{ singleItem.inputtime }}
            </div>
          </td>
          <!-- 账单状态 -->
          <td>
            <div
              style="
                height: 43px;
                line-height: 43px;
                border-right: 1px solid #e7e7e7;
              "
              v-for="(singleItem, itemIndex) in listItem.detailList"
              :key="itemIndex"
              :class="{
                tableBorderMyBtn: !(
                  listItem.detailList.length - 1 ==
                  itemIndex
                ),
              }"
            >
              <span v-if="singleItem.status == '1'">待支付</span>
              <span v-if="singleItem.status == '2'">待审核</span>
              <span v-if="singleItem.status == '3'">已完成</span>
            </div>
          </td>
          <!-- 操作 -->
          <td>
            <div
              style="height: 43px; line-height: 43px"
              v-for="(singleItem, itemIndex) in listItem.detailList"
              :key="itemIndex"
              :class="{
                tableBorderMyBtn: !(
                  listItem.detailList.length - 1 ==
                  itemIndex
                ),
              }"
            >
              <span
                v-if="singleItem.feeName"
                class="myCursor"
                @click="getDetail"
                >费用详情</span
              >
              <span style="color: #FF4D01; margin-left: 10px" class="myCursor"
                >支付</span
              >
            </div>
          </td>
        </tr>
      </tbody>
     
    </table>
     <div v-if="list.length == 0" style="line-height:100px;height:100px;width:100%;color:#999;text-align:center">
              暂无数据
      </div>
    <!-- 详情 -->
    <el-dialog
      title="费用详情"
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <div style="display: flex">
        <el-table
          :data="detail"
          :header-cell-style="{
            background: '#eef1f6',
            color: '#606266',
          }"
          
          border
          align="center"
          highlight-current-row
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="feeName" label="费用类型" width="180">
          </el-table-column>
          <el-table-column prop="name" label="费用名称"> </el-table-column>
          <el-table-column prop="amount" label="价格"> </el-table-column>
          <el-table-column prop="amount2" label="费用详情"> </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {

  data: function () {
    return {
      detail: [],
      subListId: [],
      allSelect: false,
      title: [
        "运单号",
        "费用名称",
        "应收金额",
        "费用产生时间",
        "账单状态",
        "操作",
      ],
      list: [
            {
          nos: "CTSZ201000034",
          detailList: [
            {
              id: "189394838001",
              feeName: "全包海运费1",
              amount: "102.5",
              status: "1",
              inputtime: "2020-10-12 20:10:32",
            },
            {
              id: "189394838002",
              feeName: "全包海运费2",
              amount: "102.5",
              status: "1",
              inputtime: "2020-10-12 20:10:32",
            },
            {
              id: "189394838003",
              feeName: "全包海运费3",
              amount: "102.5",
              status: "1",
              inputtime: "2020-10-12 20:10:32",
            },
          ],
        },
        {
          nos: "CTSZ201000035",
          detailList: [
            {
              id: "189394838004",
              feeName: "全包海运费3",
              amount: "102.5",
              status: "1",
              inputtime: "2020-10-12 20:10:32",
            },
            {
              id: "189394838005",
              feeName: "全包海运费2",
              amount: "102.5",
              status: "1",
              inputtime: "2020-10-12 20:10:32",
            },
            {
              id: "189394838006",
              feeName: "全包海运费1",
              amount: "102.5",
              status: "1",
              inputtime: "2020-10-12 20:10:32",
            },
          ],
        },
      ],
      selectedByIndex: [],
      arrayIdSummary:[],
      dialogVisible: false,
    };
  },
  methods: {
    getDetail() {
      this.axios
        .post("/arap/getFinaArapWebDetailList", {
          beginTime: "",
          endTime: "",
          id: 18939666000,
          status: "",
        })
        .then((res) => {
          this.detail = res.data.datas;
          this.dialogVisible = true;
        })
        .catch(res >= {});
    },
    // 全选
    allSelected(e) {
      console.log(e);
      if (e) {
        this.list.forEach((i, index) => {
          this.list[index].checked = true;
          // 改变child下面的checkd
           let temp = []
           let ids = []
          //  二级for
            this.list[index].detailList.forEach((item,index2) =>{
              item.checked = true
              temp.push(item)
              // console.log(index2)
              // 已经在computed实现
              ids.push(item.id)
            })
             this.arrayIdSummary[index] = ids
            // 子集改变状态
            this.list[index].detailList = temp
          this.$set(this.list, index, this.list[index]);
        });
       

        return;
      } else {
        this.list.forEach((i, index) => {
          this.list[index].checked = false;
           // 改变child下面的checkd
           let temp = []
             //  二级for
            this.list[index].detailList.forEach(item =>{
              item.checked = false
              temp.push(item)
            })
            // 子集改变状态
            this.list[index].detailList = temp
          this.$set(this.list, index, this.list[index]);
           this.arrayIdSummary[index] = []  
        });
      }
    },
    // 单个选择
    allSelectedChange(event, index) {
      // 第一个改变状态
      this.list[index].checked = event;
      let temp = []
      // 添加id
      // 如果true
      if(event){
        // 放入id数组集合方便后续删除
         let temId = []
        this.list[index].detailList.forEach((i,index2)=>{
        
        // this.subListId.push(this.list[index].detailList[index2].id)
       temId.push(this.list[index].detailList[index2].id)

        this.arrayIdSummary[index] = temId
     })
      // 去重
      this.subListId = [...new Set(this.subListId)]
      }else{
         this.arrayIdSummary[index] = []
      }
      
      
      this.list[index].detailList.forEach(item =>{
        item.checked = event
        temp.push(item)
      })
      // 子集改变状态
      this.list[index].detailList = temp
      this.$set(this.list, index,  this.list[index]);
      // console.log(this.allSelectValue);
    },
    // 运单号下children单个选择
    itemSelect(e,parentIndex,childIndex,id) {
      // debugger
        // true就加入
        console.log(this.arrayIdSummary[parentIndex].indexOf(id) )
       if(e){
        // 没此id就push
        // debugger
         if(this.arrayIdSummary[parentIndex].indexOf(id) == -1){
            this.arrayIdSummary[parentIndex].push(id)
         }
          
       }else{
         this.arrayIdSummary[parentIndex].forEach((idItem,idsIndex) =>{
          if(idItem == id){
               this.arrayIdSummary[parentIndex].splice(idsIndex,1)
          }
       })
       }
      let temp = []
      // 获取list里的detailist的check进行更改 后 set
      this.list[parentIndex].detailList[childIndex].checked = e    
      this.$set(this.list, parentIndex,  this.list[parentIndex]);
          let flag = false
          // 判断detail里是否有true 有的话 父级为true
          this.list[parentIndex].detailList.forEach(i =>{
              if(i.checked){
                flag = true
              }
          })
        // 运单号下children单个选中了 则勾选father的checkd
        this.list[parentIndex].checked = flag
        this.$set(this.list, parentIndex, this.list[parentIndex]);
        // console.log(parentIndex)
        // console.log(id)
        // console.log(e)
    },
  },
  computed: {
    allSelectValue() {
      let flag;

      for (let index = 0; index < this.list.length; index++) {
        if (this.list[index].checked) {
          flag = true;
          //  如果全选 添加所有id
          this.list.forEach((i) => {
            i.detailList.forEach((item) => {
              // this.subListId.push(item.id);
            });
          });
          break;
        } else {
          flag = false;
          // this.subListId = [];
          break;
        }
      }

      return flag;
    },
  },
  created() {
    this.list.forEach((i) => {
      i.checked = false;
      this.arrayIdSummary.push([])
      i.detailList.forEach(i2 =>{
        i2.checked = false
      })
    });
   
  },
};
</script>
<style  scoped>
.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
.myCursor {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/tabelTest.vue